// Components, atoms, molecules, organisms
import APAddressLookup from './../../APAddressLookup';
import APBankAccountLookup from './../../APBankAccountLookup';
import APInput, {
  APCheckbox,
  APDateInput,
  APDOBInput,
  APMultilineInput
} from './../../../atoms/APInput';
import APSelect, { APSelectCombo } from './../../../atoms/APSelect';
import APMultiSelect from './../../../atoms/APMultiSelect/APMultiSelect';
import APLabel from './../../../atoms/APLabel/APLabel';
import APLinkButton from '../../../atoms/APButton/APLinkButton';
import APHeading from '../../../atoms/APHeading';
import ErrorMessage from '../../../atoms/APAlertMessage';
import APPinField from '../../APPinField';

export const COMPONENT_DEFINITIONS: any = {
  'address': APAddressLookup,
  'bankdetails': APBankAccountLookup,
  'checkbox': APCheckbox,
  'combo': APSelectCombo,
  'date': APDateInput,
  'dob': APDOBInput,
  'default': APInput,
  'multiline': APMultilineInput,
  'select': APSelect,
  'multiselect': APMultiSelect,
  'text': APInput,
  'label': APLabel,
  'linkButton': APLinkButton,
  'sectionHeading': APHeading,
  'alertMessage': ErrorMessage,
  'securityPin' : APPinField
};
